import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Interpolate } from 'react-i18next';
import Modal from '../../components/modal';
import MemberConfirmation from '../../components/member-confirmation';
import { closeModal } from '../../actions/close-modal';
import { getUserById } from '../../selectors/user-selectors';
import { getUserById as getMemberById } from '../../selectors/search-selectors';
import withTranslate from '../../hoc/with-translate';

export const UnfollowMemberModal = ({ user, closeModal, unfollowMember, t }) =>
  <Modal onClose={closeModal}>
    <MemberConfirmation
      user={user}
      confirm={t('follow-member-modal.unfollow')}
      cancel={t('follow-member-modal.cancel')}
      onConfirm={unfollowMember}
      onCancel={closeModal}
    >
      <p>
        <Interpolate
          i18nKey="follow-member-modal.unfollow-user"
          name={<strong>
            {user.name}
          </strong>}
        />
      </p>
    </MemberConfirmation>
  </Modal>;

UnfollowMemberModal.propTypes = {
  userId: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
  unfollowMember: PropTypes.func.isRequired,
  t: PropTypes.func,
};

const mapStateToProps = (state, ownProps) => ({
  user: getUserById(state, ownProps.userId) || getMemberById(state, ownProps.userId),
});

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      closeModal,
      unfollowMember: () => closeModal(ownProps.userId),
    },
    dispatch
  );

export default _.flowRight(connect(mapStateToProps, mapDispatchToProps), withTranslate)(UnfollowMemberModal);



// WEBPACK FOOTER //
// ./app/containers/unfollow-member-modal/unfollow-member-modal.js